import Stylus from './Stylus';
import classNames from 'classnames';
import assistantStyles from '../components/Assistant/Assistant.module.css';
import React from 'react';

// Use the assistant.
class StylusAssistant extends Stylus {
  constructor({ controller }) {
    super({ controller });
  }

  activate() {
    if (window.featureFlags?.awt_390_whiteboard_ai_assistant) {
      // Open the new AI assistant sidepanel
      this.controller.actionOpenSidePanel('assistant');
    } else {
      // We don't want this to turn off the assistant when it's on. They have to
      // go through the ... menu on the assistant toolbar.
      this.controller.actionToggleAIAssistant();
    }
  }

  iconClass() {
    return classNames(
      'fa-solid fa-wand-magic-sparkles',
      assistantStyles.assistantWandIcon
    );
  }

  renderIcon() {
    if (window.featureFlags?.awt_390_whiteboard_ai_assistant) {
      return <aha-ai-icon />;
    }

    return (
      <i
        className={classNames(
          'fa-solid fa-wand-magic-sparkles',
          assistantStyles.assistantWandIcon
        )}
      />
    );
  }

  description() {
    return 'AI assistant';
  }

  toolButtonClass() {
    return 'ai-assistant-button';
  }
}

export default StylusAssistant;
